import { render, staticRenderFns } from "./StatTaskedStatisticFileComments.vue?vue&type=template&id=a86ab17c&"
import script from "./StatTaskedStatisticFileComments.vue?vue&type=script&lang=ts&"
export * from "./StatTaskedStatisticFileComments.vue?vue&type=script&lang=ts&"
import style0 from "./StatTaskedStatisticFileComments.vue?vue&type=style&index=0&id=a86ab17c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports